// extracted by mini-css-extract-plugin
export default {"loadingSpinnerContainer":"Spinner_loadingSpinnerContainer__RxTdu","loadingSpinner":"Spinner_loadingSpinner__N-SP-","spin":"Spinner_spin__zM8-M"};